// extracted by mini-css-extract-plugin
export default {"tile":"tile-module___tile___e3c3a933"};